import './CardButton.css';
function CardButtonProductWidget ({title, onClickNavigate, style, keyId}) {
    return(
        <div className="container-card-button-product" style={style} onClick={onClickNavigate} key={keyId}>
            <label className='product-desc-label'>{title}</label>
        </div>
    );

}
export default CardButtonProductWidget;